import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { toneVars } from '../../../design-system/agentTones';

/**
 * ToolFailureChip — compact "a tool failed" indicator (PRD §8.4).
 * Mirrors AgentStatusChip but pinned to the failure tone and always shows
 * the capability id for traceability.
 */
export function ToolFailureChip({
  capabilityId,
  message,
  onRetry,
  className,
  ...rest
}) {
  const vars = toneVars('failure');
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 max-w-full rounded-full border px-2 h-6 text-[11px] font-semibold orka-transition-colors',
        className,
      )}
      style={{
        ...vars,
        borderColor: 'var(--tone-border)',
        backgroundColor: 'var(--tone-soft)',
        color: 'var(--tone-color)',
      }}
      data-testid="tool-failure-chip"
      {...rest}
    >
      <AlertTriangle className="w-3 h-3 shrink-0" />
      {capabilityId && (
        <code className="font-mono text-[10px] opacity-80 truncate" data-testid="tool-failure-chip-cap">{capabilityId}</code>
      )}
      {message && <span className="truncate opacity-90">{message}</span>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="ml-1 underline underline-offset-2 orka-focus-ring rounded-sm"
          data-testid="tool-failure-chip-retry"
        >
          retry
        </button>
      )}
    </span>
  );
}

export default ToolFailureChip;
